<template>
  <div>

      <div class="row">
        <div class="col-xs-12">
          <div class="block block-bordered">
            <div class="block block-themed">
              <div class="block-header bg-muted">
                    <ul  class="block-options">

                        <li v-if="flagDisplayAlert===0">
                            <button type="button" @click="toggleDisplayAlert()"><i class="fa fa-angle-double-down fa-2x"></i></button>
                        </li>

                        <li v-if="flagDisplayAlert">
                            <button  type="button" @click="toggleDisplayAlert()"><i class="fa fa-angle-double-up fa-2x"></i></button>
                        </li>

                    </ul>
                <h2 class="block-title" @click="toggleDisplayAlert()"><i class="fa fa-bell fa-1x push-5-r "></i>{{tempoBundle.alerts[alertIndex].ReferenceName}}</h2>
              </div>

              <div v-if="flagDisplayAlert" class="block-content">

                <!-- <div class="block-header bg-gray-lighter"> -->
                    <div class="col-xs-12 push">
                      <div class="col-xs-12">
                        <h5  style="color:black">{{tempoBundle.alerts[alertIndex].AlertData.alert_title[actualLanguage]}}</h5>
                      </div>
                    </div>

                    <div v-if="alertConfigViewFlag" class="block-content">
                        <p><img class = "img-responsive" width="600px" :src="`alerts/${tempoBundle.alerts[alertIndex].AlertData.icon[actualLanguage]}` | s3Image"></p>

                        <div v-if="tempoBundle.alerts[alertIndex].AlertData.alert_description" class="col-xs-12 col-md-12 push-50">
                          <h6>{{tempoBundle.alerts[alertIndex].AlertData.alert_description[actualLanguage]}}</h6>
                        </div>


                        <div class="col-xs-12 col-md-12 push">
                          <div class="form-material">
                            <label>{{labelAlertDescription[actualLanguage]}}</label>
                            <input v-model="tempoBundle.alerts[alertIndex].AlertData.description" class="form-control" type="test" placeholder="Description">
                          </div>
                        </div>

                        <div class="col-xs-12 col-md-12 push">
                          <div class="form-material">
                            <label for="">{{labelAlertMessage[actualLanguage]}}</label>
                            <input v-model="tempoBundle.alerts[alertIndex].AlertData.message" class="form-control" type="test" placeholder="Message">
                          </div>
                        </div>

                        <div class="block-content">
                            <table class="table">
                                <thead>
                                    <tr>
                                        <th class="text-center" style="width: 75%;">{{ tableTitleParameter[actualLanguage] }}</th>
                                        <th class="text-center" style="width: 25%;">{{ tableTitleValue[actualLanguage] }}</th>
                                    </tr>
                                </thead>
                                <tbody>
                                      <tr v-for="(variableLine, index2) in tempoBundle.alerts[alertIndex].AlertData.parameters">
                                          <td class="text-center">{{ variableLine.parameterTitle[actualLanguage] }}</td>


                                          <td v-if="variableLine.dataType==='Numeric'">
                                            <input v-model="variableLine.value" class="form-control text-center" type="test" id="lock1-password" name="lock1-password" placeholder="Valeur/Value">
                                          </td>


                                          <td v-if="variableLine.dataType==='Boolean'">
                                            <label class="css-input switch switch-success">
                                              <input type="checkbox" checked v-model="variableLine.value"><span></span>
                                            </label>
                                          </td>

                                          <td v-if="variableLine.dataType==='DateMonth'">
                                            <select v-model="variableLine.value" class="form-control" size="1">
                                                      <option v-for="month in monthOptions" v-bind:value=month.value>{{ month.text }}</option>
                                            </select>
                                          </td>

                                          <td v-if="variableLine.dataType==='DateDay'">
                                            <select v-model="variableLine.value" class="form-control" size="1">
                                                      <option v-for="day in dayOptions" v-bind:value=day.value>{{ day.text }}</option>
                                            </select>
                                          </td>

                                          <td v-if="variableLine.dataType==='DateHour'">
                                            <select v-model="variableLine.value" class="form-control" size="1">
                                                      <option v-for="hour in hourOptions" v-bind:value=hour.value>{{ hour.text }}</option>
                                            </select>
                                          </td>

                                      </tr>
                                </tbody>
                            </table>
                        </div>                    
                      

                        <div class="form-group">
                          <div v-for="(variableLine, index2) in tempoBundle.alerts[alertIndex].AlertData.variables" :key="index2">
                            <div v-if="variableLine.displayFlag" class="col-xs-12 col-md-6">
                              <label for="">{{ variableLine.variableTitle[actualLanguage] }} : {{variableLine.value}}</label>
                            </div>
                          </div>
                        </div>

                          <div class="form-group">
                            <div v-for="(button, index4) in tempoBundle.alerts[alertIndex].AlertData.buttons" :key="index4">
                              <div class="col-xs-12 col-md-6">
                                  <div class="btn-group">
                                      <button class="btn btn-xs btn-default align-left" type="button" @click="alertButtonAction(index4)" data-toggle="tooltip" title="">{{button.buttonLabel[actualLanguage]}}</button>
                                  </div>
                              </div>
                            </div>
                          </div>


                        <div v-if="profileData.rights.rights.emailMultipleRecipientFlag" class="block">
                              <div class="block-content">
                                  <table class="table table-hover">
                                      <thead>
                                          <tr>
                                              <th class="text-center" style="width: 50px;">#</th>
                                              <th>{{ labelRecipientList[actualLanguage] }}</th>
                                              <th>{{ labelRecipientEmailEnable[actualLanguage] }}</th>
                                              <th>{{ labelRecipientSMSEnable[actualLanguage] }}</th>
                                              <th>{{ labelRecipientDelete[actualLanguage] }}</th>
                                          </tr>

                                      </thead>
                                      <tbody>
                                          <tr v-for="(userLine, index5) in tempoBundle.alerts[alertIndex].AlertData.users_recipient" :key="index5">
                                              <td class="text-center">{{index5+1}}</td>
                                              <td>{{ userLine.email }}</td>
                                              <td>
                                                 <div>
                                                  <input  type="checkbox" checked v-model="userLine.emailEnableFlag">
                                                </div>
                                              </td>
                                              <td>
                                                 <div v-if="profileData.rights.rights.smsFlag" >
                                                  <input  type="checkbox" checked v-model="userLine.smsEnableFlag">
                                                </div>
                                                <div v-else >
                                                  {{labelRecipientSMSNotAvailable[actualLanguage]}}
                                                </div>
                                              </td>

                                              <td class="text-center">
                                                  <div class="btn-group">
                                                      <button class="btn btn-xs btn-default" type="button" @click="confirmRemoveEmail(index5)" data-toggle="tooltip" title="Retirer/Remove"><i class="fa fa-times"></i></button>
                                                  </div>
                                              </td>
                                          </tr>
                                      </tbody>
                                  </table>
                              </div>
                              <button v-if="alertConfigEditFlag" type="button" @click="addEmail()" class="btn btn-xs" name="buttonAddPlanItem"><i class="fa fa-plus fa-1x push-5-r "></i>{{ labelFieldButtonAddRecipient[actualLanguage] }}</button>
                        </div>

                        <div v-if="actualGroupIsDefaultGroup==false" class="col-sm-12 push">
                          <label class="css-input switch switch-success">
                              <input @change="modifyActualGroupInGroupRecipient" type="checkbox" checked v-model="transmitEmailToActualGroupMember">
                              <span></span> {{ buttonLabelTransmitEmailToGroup[actualLanguage] }} {{actualGroup.group_name}}
                          </label>
                        </div>


                        <div class="row">
                          <div class="col-xs-12 col-md-12">
                            <div class="col-xs-6">
                              <button v-if="alertConfigDeleteFlag" type="button" style="color:white" @click="confirmRemoveAlertLine()" class="btn btn-danger">
                                <spinner size="small" v-if="alertIsDeleting"></spinner>
                                <span v-else><i class="fa fa-trash fa-1x push-5-r "></i>{{ labelFieldButtonDelete[actualLanguage] }}</span></button>
                            </div>
                            <div class="col-xs-6">
                              <button v-if="alertConfigEditFlag" type="button" style="color:white" @click="saveAlertModifications()" class="btn btn-success align-right" >
                                  <spinner size="small" v-if="alertIsSaving"></spinner>
                                  <span v-else><i class="fa fa-floppy-o fa-1x push-5-r "></i>{{ labelFieldButtonSave[actualLanguage] }}</span></button>
                            </div>
                          </div>
                        </div>

                      </div>

                    </div>

              </div>

            </div>
          </div>
        </div>
      </div>
    
  </div>


</template>

<script>

import _ from 'underscore'
import {mapState, mapGetters,mapActions} from 'vuex'
import Spinner from '../../components/Spinner.vue'

export default {
  props: ['alertIndex'],
    components: {
    Spinner,
  },
  data() {
    return {
      tempoBundle : {},
      displayDataTable : false,
      flagDisplayAlert : 0,
      alertIsSaving : false,
      alertIsDeleting : false,

      actualGroupIsDefaultGroup : true,

      labelAlertTitle: {FR: 'Alertes du port', EN: 'Port alerts'},
      labelFieldButtonSave: {FR: "Sauvegarder l'alerte", EN: 'Save alert'},
      labelFieldButtonDelete: {FR: "Supprimer l'alerte", EN: 'Delete this alert'},
      labelAlertSelect:{FR: "Sélectionner le type d'alerte à ajouter:", EN: 'Select type of alert to add:'},
      labelAlertDescription:{FR: "Description de l'alerte:", EN: 'Alert description:'},
      labelAlertMessage:{FR: "Message envoyé dans le courriel:", EN: 'E-mail sent message:'},

      labelRecipientList:{FR: "Liste d'utilisateur avisés:", EN: 'List of notified users:'},
      labelRecipientEmailEnable:{FR: "Courriel", EN: 'Email'},
      labelRecipientSMSEnable:{FR: "Message texte (SMS)", EN: 'Text message (SMS)'},
      labelRecipientDelete:{FR: "Effacer", EN: 'Delete'},
      labelRecipientSMSNotAvailable:{FR: "Non disponible", EN: 'Not available'},

      labelFieldButtonAddRecipient:{FR: "Ajouter un destinataire", EN: 'Add E-mail recipient'},
      labelFieldButtonAddAlert: {FR: 'Ajouter une alerte au port', EN: 'Add alert to port'},
      labelFieldButtonConfirmAddAlert: {FR: 'Ajouter', EN: 'Add'},
      labelFieldButtonCancelAddAlert: {FR: 'Annuler', EN: 'Cancel'},
      tableTitleParameter : {FR: "Paramètre(s) de l'alerte", EN: 'Alert parameter(s)'},
      tableTitleValue : {FR: "Valeur", EN: 'Value'},
      tableTitleAlertSMS : {FR: "Alerte SMS : Liste de #Téléphone", EN: 'SMS Alert : Phone number'},
      buttonLabelAddPhone : {FR: "Ajouter un numéro téléphone", EN: 'Add phone number'},      
      buttonLabelTransmitEmailToGroup: {FR: "Transmettre l'alerte aux membres du groupe:", EN: 'Transmit alert to group members:'},     


      actualLanguage : "FR",
      labelTableTop: {FR: 'Afficher le tableau des données', EN: 'Display data table'},

      alertConfigViewFlag : false,
      alertConfigEditFlag : false,
      alertConfigDeleteFlag : false,
      alertSharingEnableFlag : false,

      transmitEmailToActualGroupMember : false,


      monthOptions:[{text:'01-Jan', value:'1'},{text:'02-Fév/Feb', value:'2'},{text:'03-Mar', value:'3'},
                    {text:'04-Avr/Apr', value:'4'},{text:'05-Mai/May', value:'5'},{text:'06-Jui/Jun', value:'6'},
                    {text:'07-Jui/Jul', value:'7'},{text:'08-Aoû/Aug', value:'8'},{text:'09-Sept', value:'9'},
                    {text:'10-Oct', value:'10'},{text:'11-Nov', value:'11'},{text:'12-Déc/Dec', value:'12'}],

      dayOptions:[{text:'Lun/Mon', value:'1'},{text:'Mar/Tue', value:'2'},{text:'Mer/Wed', value:'3'},
                    {text:'Jeu/Thu', value:'4'},{text:'Ven/Fri', value:'5'},{text:'Sam/Sat', value:'6'},
                    {text:'Dim/Sun', value:'7'}],

      hourOptions:[{text:'00:00', value:'0'},{text:'01:00', value:'1'},{text:'02:00', value:'2'},{text:'03:00', value:3},{text:'04:00', value:'4'},
                  {text:'05:00', value:'5'},{text:'06:00', value:'6'},{text:'07:00', value:'7'},{text:'08:00', value:8},{text:'09:00', value:'9'},
                  {text:'10:00', value:'10'},{text:'11:00', value:'11'},{text:'12:00', value:'12'},{text:'13:00', value:13},{text:'14:00', value:'14'},
                  {text:'15:00', value:'15'},{text:'16:00', value:'16'},{text:'17:00', value:'17'},{text:'18:00', value:18},{text:'19:00', value:'19'},
                  {text:'20:00', value:'20'},{text:'21:00', value:'21'},{text:'22:00', value:'22'},{text:'23:00', value:23},{text:'24:00', value:'24'}],


    }
  },
  computed: {
    ...mapState('sessionStore', ['profileData','displayAdminFlag','actualGroup','actualBundle','navIndex']),
    ...mapState('overlayStore', ['overlayParameters']),
  },
  watch: {
    actualBundle(){
        this.reloadTempoBundle()
    },

  },

  methods: {
    ...mapActions('overlayStore', ['showModal']),
  
   toggleDisplayAlert(){
      this.flagDisplayAlert = ~this.flagDisplayAlert
    },

    reloadTempoBundle(){
        this.tempoBundle = JSON.parse(JSON.stringify(this.actualBundle))
    },

    confirmRemoveAlertLine() {
      var FlagProcessToDelete = false
      if (this.actualLanguage == "FR"){
        if (window.confirm(`Confirmer la supression de l'alerte. Cette action est irréversible!`)){
            FlagProcessToDelete = true
        }
        }else{
        if (window.confirm(`Confirm alert supression. This operation is not reversible!`)){
            FlagProcessToDelete = true            
          }
        }

      if(FlagProcessToDelete==true){
          this.alertIsDeleting = true
          var requestData = { 'postAction':'RemoveAlertFromBundle',
                              'alertIndex':this.alertIndex,
                              'alertData': this.tempoBundle.alerts[this.alertIndex].AlertData,
                              'bundleData':{'bundleId':this.actualBundle.bundle_id},
                              }
          this.$store.dispatch('sessionStore/postAlert', requestData)
              .then((response) => {
                //console.log(response.data)
                this.alertIsDeleting = false
              if(response.data.Code=='OK'){
                  this.$store.dispatch('sessionStore/getGroupArborescence')
                  this.alertShowAddButton=true
                  }
                  else{ window.alert("L'enregistrement a échoué. / Saving fail." )}
              })       
      }
    },


    addEmail() {
      if (this.actualLanguage == "FR"){
          var newEmail = prompt("Entrer l'adresse email à ajouter", "@");
        }else{
          var newEmail = prompt("Enter the E-mail to add", "@");
      }

      return this.$store.dispatch('sessionStore/validateUserExist',newEmail)
      .then((response) => {
         this.displayMessage = response.data.Message
         if (response.data.Code=='Fail'&& this.actualLanguage == "FR") window.alert('Erreur de validation !')
         if (response.data.Code=='Fail'&& this.actualLanguage == "EN") window.alert('Validation error !')

         if (response.data.Code=='E01' && this.actualLanguage == "FR") window.alert("L'utilisateur n'existe pas dans le system EV Sens!")
         if (response.data.Code=='E01' && this.actualLanguage == "EN") window.alert("User don't exists in the EV Sens system")
         
         if (response.data.Code=='OK') {
              var userToAdd = {'profileId':response.data.profileId,
                                'email':newEmail,
                                'emailEnableFlag':true,
                                'smsEnableFlag':false}
              this.tempoBundle.alerts[this.alertIndex].AlertData.users_recipient.push(userToAdd)
              if (this.actualLanguage == "FR"){
                window.alert("Vous devez Sauvegarder l'alerte pour confirmer l'enregistrement." )
              }else{
                window.alert('You must Save the alert to record modifications.')
              }
           }
        })
    },

    confirmRemoveEmail(indexEmail) {
      if (this.actualLanguage == "FR"){
        if (window.confirm(`Confirmer la supression du destinataire "${indexEmail+1}". Cette action est irréversible suite à la sauvegarde de l'alerte!`)){
            this.tempoBundle.alerts[this.alertIndex].AlertData.users_recipient.splice(indexEmail,1)
            window.alert("Vous devez Sauvegarder l'alerte pour confirmer l'enregistrement." )
        }
        }else{
        if (window.confirm(`Confirm recipient "${indexEmail+1}" supression. This operation is not reversible after alert saving!`)){
            this.tempoBundle.alerts[this.alertIndex].AlertData.users_recipient.splice(indexEmail,1)
            window.alert('You must Save the alert to record modifications.')
        }
      }
    },



    modifyActualGroupInGroupRecipient(){
      //console.log(this.tempoBundle.alerts[this.alertIndex])
      if(this.transmitEmailToActualGroupMember){
        //On valide si le groupe actuel est dans la liste, si non trouvé on l'ajoute
        var flagGroupFound = false
        for(var m=0;m<this.tempoBundle.alerts[this.alertIndex].AlertData.group_recipient.length;m++){
          if(this.tempoBundle.alerts[this.alertIndex].AlertData.group_recipient[m]==this.actualGroup.group_id){flagGroupFound=true}
        }
        if(flagGroupFound==false){this.tempoBundle.alerts[this.alertIndex].AlertData.group_recipient.push(this.actualGroup.group_id)}

      }else{
        var indexToRemove = -1
        for(var m=0;m<this.tempoBundle.alerts[this.alertIndex].AlertData.group_recipient.length;m++){
          if(this.tempoBundle.alerts[this.alertIndex].AlertData.group_recipient[m]==this.actualGroup.group_id){indexToRemove=m}
        }        
        if(indexToRemove>-1){this.tempoBundle.alerts[this.alertIndex].AlertData.group_recipient.pop(indexToRemove)}
      }
      
      //console.log(this.tempoBundle.alerts[this.alertIndex].AlertData.group_recipient)
    },

    validateActualGroupInGroupRecipient(){
      //console.log(this.tempoBundle.alerts[this.alertIndex])

        //On valide si le groupe actuel est dans la liste, si non trouvé on l'ajoute
        var flagGroupFound = false
        for(var m=0;m<this.tempoBundle.alerts[this.alertIndex].AlertData.group_recipient.length;m++){
          if(this.tempoBundle.alerts[this.alertIndex].AlertData.group_recipient[m]==this.actualGroup.group_id){
            this.transmitEmailToActualGroupMember=true
            }
        }

    },    


    alertButtonAction(indexButton){

        if (window.confirm(this.tempoBundle.alerts[this.alertIndex].AlertData.buttons[indexButton].confirmationMessage[this.actualLanguage])){
          var requestData = { 'postAction':this.tempoBundle.alerts[this.alertIndex].AlertData.buttons[indexButton].alertPostAction,
                              'alertLinkedBundle':this.tempoBundle.alerts[this.alertIndex].AlertData.alert_linked_bundle,
                              'alertId':this.tempoBundle.alerts[this.alertIndex].AlertData.alert_id}

          this.$store.dispatch('sessionStore/postAlert', requestData)
              .then((response) => {
                //console.log(response)
              if(response.data.Code=='OK'){
                    window.alert(this.tempoBundle.alerts[this.alertIndex].AlertData.buttons[indexButton].successMessage[this.actualLanguage])            
                  }
                  else{
                    //console.log(response)
                    window.alert(this.tempoBundle.alerts[this.alertIndex].AlertData.buttons[indexButton].errorMessage[this.actualLanguage])
                  }
              })
        }
    },



    saveAlertModifications() {
        this.alertIsSaving = true
        var requestData = { 'postAction':'SaveAlertModification',
                            'alertData':this.tempoBundle.alerts[this.alertIndex].AlertData,

                            }
        this.$store.dispatch('sessionStore/postAlert', requestData)
            .then((response) => {
              //console.log(response.data)
              this.alertIsSaving = false
            if(response.data.Code=='OK'){
                //this.$store.dispatch('sessionStore/getGroupArborescence')
                this.$store.dispatch('sessionStore/reloadActualBundle')
                this.alertShowAddButton=true
                }
                else{ window.alert("L'enregistrement a échoué. / Saving fail." )}
            })       
      
    },

    shareEntity(){
      var modalParameters = {'modalTitle':{FR: "Partage d'alerte", EN: 'Alert sharing'},
                        'entityOwner':this.actualBundle.bundle_id,
                        'sharingType':'Alert',
                        'entityId':this.actualBundle.alerts[this.alertIndex].AlertData.alert_id,
                        'entityReferenceName':this.actualBundle.alerts[this.alertIndex].ReferenceName,
                        'displayAlertOptions':true,
                        'displayChannelOptions':false,
                        'displayDeviceOptions':false,
                        'displayBundleOptions':false,
                        'displayGroupOptions':false,
                        'displayUserOptions':false}

      this.$store.dispatch('overlayStore/setParameters',modalParameters)
      this.showModal('config-access-rules-form')
    },

    findPermissionItemValue(permissionList,idToFind){
        var value = false
        for (var n = 0; n < permissionList.length; n++){
          if(permissionList[n].id == idToFind)
          {value = permissionList[n].value
          //console.log('Value Found')
          }
        }
        return value
    },

  },

  mounted() {
    //Retirer l'inversion puisque le composant PortGraph effectue l'inversion sur la variable 
    //this.tableData = this.portData.reverse();
    //this.tableData = this.portData;

   this.alertConfigViewFlag = this.findPermissionItemValue(this.actualBundle.alerts[this.alertIndex].AlertData.permissions,'alertConfigView')
   this.alertConfigEditFlag = this.findPermissionItemValue(this.actualBundle.alerts[this.alertIndex].AlertData.permissions,'alertConfigEdit')
   this.alertConfigDeleteFlag = this.findPermissionItemValue(this.actualBundle.alerts[this.alertIndex].AlertData.permissions,'alertConfigDelete')
   this.alertSharingEnableFlag = this.findPermissionItemValue(this.actualBundle.alerts[this.alertIndex].AlertData.permissions,'alertSharingEnable')

   this.actualGroupIsDefaultGroup = this.actualGroup.group_id.includes('::DefaultGroup')
   this.validateActualGroupInGroupRecipient()


    if(localStorage.language){this.actualLanguage =  localStorage.language}
      else{this.actualLanguage = 'FR'}
  },

  
  beforeMount(){
    this.reloadTempoBundle()
  }

}
</script>

<style lang="css">
</style>



// WEBPACK FOOTER //
// ConfigAlert.vue?74bebfa3